import {
    Prime,
    QuotationCalculated,
} from "../../containers/quotation/types/quotation";
import { TypeRates } from "../../constants/enums/quotation";
import { RANGE_OF_EMPLOYEES } from "../../constants/enums/range-of-employees";

export type QuotationState = {
    annual: Prime;
    semester: Prime;
    initialMonth: string;
    isAbleToContinue: boolean;
    calculated: {
        [TypeRates.ANNUAL]: QuotationCalculated;
        [TypeRates.SEMESTER]: QuotationCalculated;
    };
    primeSelected: TypeRates;
    showLoading: boolean;
    workersRange: typeof RANGE_OF_EMPLOYEES;
};

export const quotationDefaultState: QuotationState = {
    annual: {
        typeRate: TypeRates.ANNUAL,
        monthlyPrime: null,
        ratePrime: null,
        totalPrime: 0,
    },
    semester: {
        typeRate: TypeRates.SEMESTER,
        monthlyPrime: null,
        ratePrime: null,
        totalPrime: 0,
    },
    initialMonth: `${`0${new Date().getMonth() + 2}`.slice(
        -2
    )}/${new Date().getFullYear()}`,
    isAbleToContinue: false,
    calculated: {
        [TypeRates.ANNUAL]: null,
        [TypeRates.SEMESTER]: null,
    },
    primeSelected: TypeRates.ANNUAL,
    showLoading: false,
    workersRange: null,
};
